export const translations = {
  ar: {
    // Auth
    medtrack: 'نظام إدارة المندوبين الطبيين',
    medtrackShort: 'EP-EG',
    username: 'اسم المستخدم',
    password: 'كلمة المرور',
    signIn: 'تسجيل الدخول',
    signingIn: 'جاري تسجيل الدخول...',
    logout: 'تسجيل الخروج',
    demoCredentials: 'للدعم الفني على مدار الساعة واتس اب',
    enterUsername: 'أدخل اسم المستخدم',
    enterPassword: 'أدخل كلمة المرور',

    // Common
    dashboard: 'لوحة التحكم',
    clinics: 'العيادات',
    visits: 'الزيارات',
    plans: 'الخطط',
    managePlansDesc: 'إدارة خطط الزيارات الشهرية للعيادات',
    orders: 'الطلبات',
    expenses: 'المصروفات',
    users: 'المستخدمين',
    products: 'المنتجات',
    approvals: 'الموافقات',
    gpsTracking: 'تتبع الموقع',
    activityMap: 'خريطة النشاط',
    activityHistory: 'سجل النشاط',
    exportCsv: 'تصدير CSV',
    inactive: 'غير نشط',
    startDate: 'تاريخ البداية',
    endDate: 'تاريخ النهاية',
    apply: 'تطبيق',
    clear: 'مسح',
    inactiveUsersAlert: 'تنبيه المستخدمين غير النشطين',
    inactivityThreshold: 'حد الخمول',
    noActivityLogs: 'لا توجد سجلات نشاط لهذا المستخدم.',
    noGpsData: 'لم يتم التقاط بيانات GPS',
    toggleDarkLight: 'تبديل الوضع الداكن/الفاتح',
    saving: 'جاري الحفظ...',
    saveSiteConfiguration: 'حفظ إعدادات الموقع',
    gpsVerified: 'تم التحقق من GPS',
    settings: 'الإعدادات',
    returns: 'المرتجعات',
    accounting: 'الحسابات',
    inventory: 'المخزن',
    performance: 'الأداء',
    manageClinicInfo: 'إدارة معلومات العيادات',
    trackClinicVisits: 'تتبع زيارات العيادات',
    manageOrders: 'إدارة الطلبات',
    trackExpenses: 'تتبع وإدارة المصروفات',
    manageTeam: 'إدارة أعضاء الفريق والصلاحيات',
    monitorLocations: 'مراقبة مواقع المندوبين الميدانيين',
    availableClinics: 'العيادات المتاحة',
    totalVisits: 'إجمالي الزيارات',
    ordersCompleted: 'الطلبات المكتملة',
    pendingApproval: 'في انتظار الموافقة',
    logVisit: 'تسجيل زيارة',
    recordClinicVisit: 'تسجيل زيارة عيادة',
    addExpense: 'إضافة مصروف',
    submitExpenseClaim: 'تقديم طلب مصروف',
    registerNewClinic: 'تسجيل عيادة جديدة',
    youHaveOrdersWaiting: 'لديك',
    ordersWaitingApproval: 'طلبات بانتظار الموافقة',
    welcome: 'مرحباً',
    quickActions: 'الإجراءات السريعة',
    manageClinics: 'إدارة العيادات',
    viewVisits: 'عرض الزيارات',
    manageUsers: 'إدارة المستخدمين',
    userPerformanceStats: 'إحصائيات أداء المستخدم',
    totalExpenses: 'إجمالي المصروفات',
    ordersValue: 'قيمة الطلبات',
    totalExpensesAmount: 'إجمالي مبلغ المصروفات',
    changePasswordOptional: 'تغيير كلمة المرور (اختياري)',
    allReturns: 'جميع المرتجعات',
    processed: 'تمت المعالجة',
    returnId: 'رقم المرتجع',
    orderId: 'رقم الطلب',
    markAsProcessed: 'وضع علامة تمت المعالجة',
    confirmReject: 'تأكيد الرفض',

    // Roles
    superAdmin: 'المدير العام',
    gm: 'المدير التنفيذي',
    manager: 'المدير',
    medicalRep: 'مندوب طبي',
    accountant: 'محاسب',
    lastLogin: 'آخر تسجيل دخول',
    noLine: 'بدون خط',
    noArea: 'بدون منطقة',

    // Dashboard titles
    superAdminDashboard: 'لوحة تحكم المدير العام',
    gmDashboard: 'لوحة تحكم المدير التنفيذي',
    managerDashboard: 'لوحة تحكم المدير',
    fieldDashboard: 'لوحة التحكم الميدانية',

    // Stats
    organizations: 'المؤسسات',
    totalUsers: 'إجمالي المستخدمين',
    totalClinics: 'إجمالي العيادات',
    totalVisits: 'إجمالي الزيارات',
    teamMembers: 'أعضاء الفريق',
    activeTracking: 'التتبع النشط',

    // Actions
    create: 'إنشاء',
    add: 'إضافة',
    edit: 'تعديل',
    delete: 'حذف',
    save: 'حفظ',
    cancel: 'إلغاء',
    submit: 'إرسال',
    update: 'تحديث',
    close: 'إغلاق',

    // Organizations
    newOrganization: 'مؤسسة جديدة',
    createOrganization: 'إنشاء مؤسسة',
    organizationName: 'اسم المؤسسة',
    address: 'العنوان',
    phone: 'الهاتف',
    manageAllOrgs: 'إدارة جميع المؤسسات والمستخدمين',
    noOrganizations: 'لا توجد مؤسسات بعد',
    createFirstOrg: 'قم بإنشاء مؤسسة للبدء',

    // Clinics
    addClinic: 'إضافة عيادة',
    clinicName: 'اسم العيادة',
    doctorName: 'اسم الطبيب',
    specialty: 'التخصص',
    email: 'البريد الإلكتروني',
    gpsLocation: 'الموقع الجغرافي',
    captureLocation: 'تسجيل الموقع الحالي',
    locationCaptured: 'تم تسجيل الموقع',
    creating: 'جاري الإنشاء...',
    noClinics: 'لا توجد عيادات بعد',
    addFirstClinic: 'أضف عيادتك الأولى للبدء',
    // Clinic Dialog - NEW
    editClinic: 'تعديل العيادة',
    registerNewClinic: 'تسجيل عيادة جديدة',
    editClinicData: 'تعديل بيانات العيادة',
    completeRequiredInfo: 'أكمل جميع المعلومات المطلوبة',
    locationOnMap: 'الموقع على الخريطة',
    locatingPosition: 'جاري تحديد الموقع...',
    locationSet: 'تم تحديد الموقع:',
    clinicData: 'بيانات العيادة',
    line: 'الخط',
    area: 'المنطقة',
    doctorPhone: 'هاتف الطبيب',
    clinicPhone: 'هاتف العيادة',
    classifications: 'التصنيفات',
    clinicClassification: 'تصنيف العيادة',
    creditClassification: 'تصنيف الائتمان',
    saving: 'جاري الحفظ...',
    updateClinic: 'تحديث العيادة',
    accountStatement: 'كشف الحساب',
    comingSoon: 'قريباً',
    invoices: 'الفواتير',
    totalOrders: 'إجمالي الطلبات',
    totalVisits: 'إجمالي الزيارات',
    team: 'الفريق',
    overview: 'نظرة عامة',
    clinicInformation: 'معلومات العيادة',
    doctor: 'الطبيب',
    classification: 'التصنيف',
    class: 'فئة',
    topOrderedProducts: 'أكثر المنتجات طلباً',
    units: 'وحدة',
    authorizedMedicalReps: 'المندوبين المعتمدين',
    authorizedRepsDescription: 'المندوبين المعينين على نفس الخط يمكنهم زيارة هذه العيادة',
    noAuthorizedReps: 'لا يوجد مندوبين معتمدين',
    completed: 'مكتمل',
    pending_approval: 'بانتظار الموافقة',

    // Clinics Form - Additional translations
    accuracyUltra: 'دقة متناهية',
    accuracyHigh: 'دقة عالية',
    accuracyMedium: 'دقة متوسطة',
    accuracyLow: 'دقة منخفضة',
    nearbyClinicsWarning: 'يوجد {count} عيادة قريبة جداً من هذا الموقع!',
    ensureNewClinic: 'تأكد أن هذه عيادة جديدة وليست مسجلة من قبل',
    dismissWarning: 'تجاهل التحذير',
    searchAddress: 'البحث عن العنوان',
    addressSearchPlaceholder: 'اكتب اسم الشارع أو العنوان للبحث...',
    mapInstructions: 'اضغط أو اسحب الدبوس لتحديد الموقع',
    locationInstructions: 'اضغط على زر 📍 على الخريطة لتحديد موقعك • أو اضغط على أي مكان لوضع الدبوس يدوياً',
    selectLine: 'اختر الخط',
    selectArea: 'اختر المنطقة',
    detailedAddress: 'العنوان التفصيلي',
    addressPlaceholder: 'العنوان الكامل مع المعالم',
    clinicNamePlaceholder: 'أدخل اسم العيادة',
    doctorNamePlaceholder: 'د. الاسم الكامل',
    specialtyPlaceholder: 'مثل: قلب، أطفال',
    doctorPhonePlaceholder: 'رقم الطبيب المباشر',
    clinicPhonePlaceholder: 'رقم العيادة الرئيسي',
    classificationExcellent: 'ممتاز',
    classificationGood: 'جيد',
    classificationNormal: 'عادي',
    creditExcellent: 'ممتاز',
    creditGood: 'جيد',
    creditDanger: 'خطر',
    classificationNotes: 'ملاحظات التصنيف',
    classificationNotesPlaceholder: 'ملاحظات حول معايير التصنيف...',
    registrationNotes: 'ملاحظات التسجيل',
    registrationNotesPlaceholder: 'معلومات إضافية للتسجيل...',
    registerClinic: 'تسجيل العيادة',
    noClinicsRegistered: 'لا توجد عيادات مسجلة',
    startRegisteringClinics: 'ابدأ بتسجيل أول عيادة',
    confirmDeleteClinic: 'هل أنت متأكد من حذف هذه العيادة؟',
    clinicDeletedSuccess: 'تم حذف العيادة بنجاح',
    clinicDeleteFailed: 'فشل في حذف العيادة',
    clinicUpdatedSuccess: 'تم تحديث العيادة بنجاح',
    clinicCreatedSuccess: 'تم تسجيل العيادة بنجاح',
    selectLineAndArea: 'يرجى اختيار الخط والمنطقة',
    clinicSaveFailed: 'فشل في حفظ العيادة',
    failedToLoadClinics: 'فشل تحميل العيادات',
    failedToLoadLines: 'فشل تحميل الخطوط',
    failedToLoadAreas: 'فشل تحميل المناطق',
    locationTrackingStopped: 'تم إيقاف تتبع الموقع',
    gpsLocationError: 'خطأ في تتبع الموقع - يرجى تحريك الدبوس يدوياً',
    gpsLocationFailed: 'فشل في تحديد الموقع - تأكد من تفعيل GPS',
    metricMeters: 'متر',
    moreClinics: '+ {count} عيادات أخرى',
    areaAutoSelected: 'تم اختيار المنطقة تلقائياً',
    gpsHighAccuracy: 'جاري تحديد موقعك بدقة عالية...',
    gpsSearchingSignal: 'جاري البحث عن إشارة GPS... قد يستغرق بضع ثوانٍ',
    gpsCurrentAccuracy: 'الدقة الحالية: {accuracy}م - جاري التحسين...',
    gpsExcellentAccuracy: 'تم تحديد موقعك بدقة متناهية: {accuracy} متر 🎯',
    gpsImprovingBackground: 'الدقة الحالية: {accuracy}م - جاري التحسين في الخلفية...',
    myLocationButton: 'تحديد موقعي الحالي',

    // Visits
    logVisit: 'تسجيل زيارة',
    clinic: 'العيادة',
    selectClinic: 'اختر العيادة',
    verifyLocation: 'التحقق من الموقع',
    updateLocation: 'تحديث الموقع',
    notes: 'ملاحظات',
    addVisitNotes: 'أضف أي ملاحظات عن الزيارة...',
    logging: 'جاري التسجيل...',
    verified: 'تم التحقق',
    pending: 'قيد الانتظار',
    locationVerified: 'تم التحقق من الموقع ضمن نطاق 1 كم',
    locationCapturedNotVerified: 'تم تسجيل الموقع ولكن ليس ضمن نطاق 1 كم',
    noVisits: 'لم يتم تسجيل زيارات بعد',
    startTracking: 'ابدأ تتبع زيارات العيادات',
    visitsReference: 'سجل الزيارات',
    manageFieldVisits: 'إدارة وتتبع زياراتك الميدانية',
    editVisit: 'تعديل الزيارة',
    visitDetails: 'تفاصيل الزيارة',
    noVisitsRecorded: 'لم يتم تسجيل زيارات',
    logFirstVisit: 'سجل زيارتك الأولى لتظهر هنا',
    visitReason: 'سبب الزيارة',
    visitResult: 'نتيجة الزيارة',
    attendees: 'الحاضرون',
    samplesProvided: 'العينات المقدمة',
    addSample: 'إضافة عينة',
    followUpDate: 'تاريخ المتابعة',
    visitRating: 'تقييم الزيارة',
    outcome: 'النتيجة',
    clickForDetails: 'انقر للتفاصيل',
    processing: 'جاري المعالجة...',
    deleteVisitRecord: 'حذف سجل الزيارة',
    confirmDeleteVisit: 'هل أنت متأكد؟ سيتم حذف سجل الزيارة من النظام بشكل دائم.',
    updateVisitLog: 'تحديث سجل الزيارة',
    logNewVisit: 'تسجيل زيارة جديدة',
    successful: 'ناجحة',
    doctorInterested: 'الطبيب مهتم',
    needsFollowUp: 'تحتاج متابعة',
    personAbsent: 'الشخص غائب',
    followUp: 'متابعة / صيانة',
    newProductLaunch: 'إطلاق منتج جديد',
    productDemo: 'عرض المنتج',
    placeOrderReason: 'تقديم طلب',
    issueResolution: 'حل مشكلة',
    clinicOpening: 'افتتاح عيادة',
    noneLogged: 'لم يتم التسجيل',
    unknownClinic: 'عيادة غير معروفة',
    free: 'مجاني',
    discountApplied: 'تم تطبيق خصم',
    rejectionReasonPrompt: 'يرجى تقديم سبب لرفض هذا الطلب. سيتم إرساله للمندوب.',
    confirmRejection: 'تأكيد الرفض',
    verifiedVisit: 'زيارة موثقة',
    gridView: 'عرض شبكي',
    listView: 'عرض قائمة',
    detailedView: 'عرض تفصيلي',
    result: 'النتيجة',
    reason: 'السبب',
    rating: 'التقييم',
    selectReason: 'اختر السبب',
    selectResult: 'اختر النتيجة',
    product: 'المنتج',
    qty: 'الكمية',
    keyTakeaways: 'النقاط الرئيسية، ملاحظات الطبيب، إلخ.',
    notes: 'ملاحظات',
    notesPlaceholder: 'ملاحظات ونقاط مهمة من الزيارة...',
    outcome: 'النتيجة',
    verified: 'تم التحقق',
    verifiedVisit: 'زيارة مُتحقق منها',
    status_completed: 'مكتملة',
    status_planned: 'مخططة',
    status_cancelled: 'ملغاة',
    status_pending: 'قيد الانتظار',

    // Orders
    totalOrders: 'إجمالي الطلبات',
    totalRevenue: 'إجمالي الإيرادات',
    today: 'اليوم',
    thisWeek: 'هذا الأسبوع',
    timeline: 'التسلسل الزمني',
    comments: 'التعليقات',
    discountOptional: 'الخصم (اختياري)',
    discountType: 'نوع الخصم',
    discountValue: 'قيمة الخصم',
    discountReason: 'سبب الخصم',
    subtotal: 'المجموع الفرعي',
    discount: 'الخصم',
    rejectionReason: 'سبب الرفض',
    downloadInvoice: 'تحميل الفاتورة',
    duplicate: 'نسخ',
    orderAgain: 'طلب مرة أخرى',
    restore: 'استعادة',
    createOrder: 'إنشاء طلب',
    products: 'المنتجات',
    addProduct: 'إضافة منتج',
    orderType: 'نوع الطلب',
    regularOrder: 'طلب عادي',
    demoOrder: 'عينات مجانية',
    demoOrderNote: 'طلبات العينات: حد أقصى 6 منتجات، كمية واحدة لكل منتج، مجاني',
    productName: 'اسم المنتج',
    quantity: 'الكمية',
    price: 'السعر',
    totalAmount: 'المبلغ الإجمالي',
    status: 'الحالة',
    draft: 'مسودة',
    submitted: 'تم الإرسال',
    approved: 'تمت الموافقة',
    delivered: 'تم التسليم',
    noOrders: 'لا توجد طلبات بعد',
    createFirstOrder: 'قم بإنشاء طلبك الأول',
    noTimelineHistory: 'لا يوجد سجل زمني بعد',
    noComments: 'لا توجد تعليقات بعد',
    noUsers: 'لا يوجد مستخدمين بعد',
    noLinesYet: 'لم يتم إنشاء خطوط بعد',
    noAreasYet: 'لم يتم إنشاء مناطق بعد',
    addLine: 'إضافة خط',
    editLine: 'تعديل الخط',
    lineName: 'اسم الخط',
    createLine: 'إنشاء الخط',
    updateLine: 'تحديث الخط',
    addArea: 'إضافة منطقة',
    editArea: 'تعديل المنطقة',
    areaName: 'اسم المنطقة',
    selectLine: 'اختر الخط',
    createArea: 'إنشاء المنطقة',
    updateArea: 'تحديث المنطقة',
    systemHealth: 'صحة النظام',
    monitorDbStatus: 'مراقبة حالة قاعدة البيانات والنظام',
    lines: 'الخطوط',
    manageCompanyLines: 'إدارة خطوط الشركة',
    areas: 'المناطق',
    manageGeoAreas: 'إدارة المناطق الجغرافية',

    // Expenses
    addExpense: 'إضافة مصروف',
    expenseType: 'نوع المصروف',
    amount: 'المبلغ',
    date: 'التاريخ',
    description: 'الوصف',
    receiptUrl: 'رابط الإيصال',
    addExpenseDetails: 'أضف تفاصيل حول هذا المصروف...',
    submitting: 'جاري الإرسال...',
    submitExpense: 'إرسال المصروف',
    viewReceipt: 'عرض الإيصال',
    noExpenses: 'لا توجد مصروفات بعد',
    submitFirstExpense: 'قدم مطالبة المصروف الأولى',
    // Expense Categories
    expenseCategory: 'فئة المصروف',
    categoryTravel: 'السفر',
    categoryMeals: 'الوجبات',
    categoryAccommodation: 'الإقامة',
    categoryTransportation: 'المواصلات',
    categorySupplies: 'المستلزمات',
    categoryCommunication: 'الاتصالات',
    categoryEntertainment: 'الترفيه',
    categoryMedical: 'طبي',
    categoryOther: 'أخرى',
    // Expense Approval
    pendingApproval: 'بانتظار الموافقة',
    myExpenses: 'مصروفاتي',
    approveExpense: 'الموافقة على المصروف',
    rejectExpense: 'رفض المصروف',
    rejectionReason: 'سبب الرفض',
    expenseApproved: 'تمت الموافقة على المصروف',
    expenseRejected: 'تم رفض المصروف',
    uploadReceipt: 'تحميل الإيصال',
    receiptUploaded: 'تم تحميل الإيصال',
    submitForApproval: 'إرسال للموافقة',
    noPendingApprovals: 'لا توجد موافقات معلقة',
    allExpensesReviewed: 'تمت مراجعة جميع المصروفات',
    submittedBy: 'مقدم من',

    // Users
    addUser: 'إضافة مستخدم',
    fullName: 'الاسم الكامل',
    role: 'الدور',
    organization: 'المؤسسة',
    selectOrganization: 'اختر المؤسسة',
    access: 'الصلاحية',
    gps: 'التتبع',
    noUsers: 'لا يوجد مستخدمون بعد',
    addTeamMembers: 'أضف أعضاء الفريق للبدء',

    // GPS
    gpsTrackingDisabled: 'تتبع GPS معطل',
    enableToLog: 'قم بالتفعيل لتسجيل أنشطتك الميدانية',
    enableGPS: 'تفعيل GPS',
    gpsTrackingActive: 'تتبع GPS نشط',
    location: 'الموقع',
    latitude: 'خط العرض',
    longitude: 'خط الطول',
    accuracy: 'الدقة',
    selectMedicalRep: 'اختر المندوب الطبي',
    currentUser: 'المستخدم الحالي',
    latestLocation: 'آخر موقع',
    locationHistory: 'سجل المواقع',
    noGpsLogs: 'لم يتم العثور على سجلات GPS',
    locationTrackingWillAppear: 'سيظهر تتبع الموقع هنا عندما يقوم المستخدم بتفعيل GPS',
    mapView: 'عرض الخريطة',
    mapIntegration: 'تكامل الخريطة',
    viewOnGoogleMaps: 'عرض على خرائط جوجل',
    activity: 'النشاط',

    // Quick Actions
    quickActions: 'إجراءات سريعة',
    manageClinics: 'إدارة العيادات',
    viewVisits: 'عرض الزيارات',
    manageUsers: 'إدارة المستخدمين',
    registerClinic: 'تسجيل عيادة جديدة',
    recordVisit: 'تسجيل زيارة عيادة',
    placeOrder: 'تقديم طلب جديد',
    submitExpenseClaim: 'تقديم مطالبة مصروف',
    controlAccess: 'التحكم بالصلاحيات والأذونات',
    monitorReps: 'مراقبة المندوبين الميدانيين',
    trackActivities: 'تتبع أنشطة الزيارات',

    // Messages
    loginSuccessful: 'تم تسجيل الدخول بنجاح',
    loginFailed: 'فشل تسجيل الدخول',
    createdSuccessfully: 'تم الإنشاء بنجاح',
    updatedSuccessfully: 'تم التحديث بنجاح',
    deletedSuccessfully: 'تم الحذف بنجاح',
    operationFailed: 'فشلت العملية',
    gpsEnabled: 'تم تفعيل تتبع GPS',
    gpsDisabled: 'تم تعطيل تتبع GPS',
    locationCapturedSuccess: 'تم تسجيل الموقع!',

    // Status
    active: 'نشط',
    inactive: 'غير نشط',

    // Welcome
    welcomeBack: 'مرحباً بعودتك',
    overviewActivities: 'نظرة عامة على أنشطة مؤسستك',
    manageTeamMonitor: 'إدارة فريقك ومراقبة الأنشطة',

    // Search
    searchPlaceholder: 'البحث في العيادات، المستخدمين، الطلبات...',
    noResultsFor: 'لا توجد نتائج لـ',

    // Dashboard - NEW
    adminDashboard: 'لوحة تحكم المدير',
    systemOverview: 'نظرة عامة على أداء النظام',
    pendingOrders: 'طلبات معلقة',
    pendingExpenses: 'مصروفات معلقة',
    activeReps: 'المندوبون النشطون',
    today: 'اليوم',
    thisWeek: 'هذا الأسبوع',
    totalRevenue: 'إجمالي الإيرادات',
    fromApprovedOrders: 'من الطلبات المعتمدة',
    weeklyTrends: 'اتجاهات الأسبوع',
    topPerformers: 'أفضل المندوبين',
    dailyActivity: 'النشاط اليومي',
    recentActivities: 'الأنشطة الأخيرة',
    noDataAvailable: 'لا توجد بيانات',
    noRecentActivities: 'لا توجد أنشطة حديثة',

    // Date formatting
    naLabel: 'غير متوفر',
    invalidDate: 'تاريخ غير صالح',

    // Settings - NEW
    siteConfiguration: 'إعدادات الموقع',
    siteTitle: 'عنوان الموقع',
    logoUrl: 'رابط الشعار',
    gpsSettings: 'إعدادات الموقع الجغرافي',
    systemHealth: 'صحة النظام',
    sessionsManagement: 'إدارة الجلسات',
    customFields: 'الحقول المخصصة',
    dataExport: 'تصدير البيانات',
    dataImport: 'استيراد البيانات',
    saveSettings: 'حفظ الإعدادات',
    uploadLogo: 'تحميل الشعار',
    exportData: 'تصدير البيانات',
    importData: 'استيراد البيانات',
    terminateSession: 'إنهاء الجلسة',
    activeSessions: 'الجلسات النشطة',

    // Expenses Tabs - NEW
    myExpensesTab: 'مصروفاتي',
    pendingApprovalTab: 'بانتظار الموافقة',
    allExpensesTab: 'كل المصروفات',
    addNewExpense: 'إضافة مصروف جديد',
    expenseAmount: 'مبلغ المصروف',

    // Orders - NEW
    analytics: 'التحليلات',
    filters: 'الفلاتر',
    exportPdf: 'تصدير PDF',
    allOrders: 'كل الطلبات',
    allTeamOrders: 'كل طلبات الفريق',
    orderDetails: 'تفاصيل الطلب',
    processing: 'قيد المعالجة',
    shipped: 'تم الشحن',
    rejected: 'مرفوض',
    duplicate: 'نسخ',
    orderAgain: 'طلب مرة أخرى',
    restore: 'استعادة',
    invoiceDownloaded: 'تم تحميل الفاتورة',

    // New Features - Filters & Plans
    progress: 'الإنجاز',
    weekNumber: 'رقم الأسبوع',
    weeklyGoal: 'هدف الأسبوع',
    priority: 'الأولوية',
    priorityHigh: 'عالية',
    priorityMedium: 'متوسطة',
    priorityLow: 'منخفضة',
    conflictDetected: 'تم اكتشاف تضارب',
    conflictSameClinic: 'زيارتان لنفس العيادة في نفس اليوم',
    conflictMultipleVisits: 'زيارات متعددة في نفس اليوم',
    clearFilters: 'مسح الفلاتر',
    searchPlaceholder: 'بحث بالعيادة أو الملاحظات...',
    showing: 'عرض',
    outOf: 'من أصل',
    dateFrom: 'من تاريخ',
    dateTo: 'إلى تاريخ',
    allClinics: 'كل العيادات',
    allReasons: 'كل الأسباب',
    productivityToday: 'إنتاجية اليوم',
    dailyGoal: 'الهدف اليومي',
    visitsCompleted: 'زيارات مكتملة',
    ordersToday: 'طلبات اليوم',

    // NEW: Missing translations
    // Placeholders
    selectProduct: 'اختر المنتج',
    selectType: 'اختر النوع',
    discountReason: 'سبب الخصم...',
    addNotes: 'أضف ملاحظات...',
    searchProducts: 'البحث بالمنتج أو رقم الطلب...',
    allStatuses: 'كل الحالات',
    addComment: 'أضف تعليق...',
    selectLine: 'اختر الخط',
    productExample: 'مثال: سيروم فيتامين سي',
    skuExample: 'مثال: VIT-C-001',
    productDescription: 'وصف المنتج...',
    noManager: 'بدون مدير (المستخدم مدير)',
    selectLineOptional: 'اختر الخط (اختياري)',
    selectAreaOptional: 'اختر المنطقة (اختياري)',
    leaveEmptyPassword: 'اتركه فارغاً للإبقاء على كلمة المرور الحالية',
    expenseExample: 'مثال: بنزين، غداء، فندق',
    selectCategory: 'اختر الفئة',
    expenseExplain: 'اشرح الغرض من هذا المصروف...',
    enterRejection: 'أدخل سبب الرفض...',
    enterReasonRejection: 'أدخل سبب الرفض...',
    rejectionExample: 'مثال: الخصم مرتفع جداً، المنتج غير متوفر...',
    selectUser: 'اختر المستخدم',
    selectStyle: 'اختر النمط',
    samplesProvided: 'العينات المقدمة',
    editVisit: 'تعديل الزيارة',
    close: 'إغلاق',
    unknownUser: 'مستخدم غير معروف',

    // Titles & Headers
    editProduct: 'تعديل المنتج',
    editOrder: 'تعديل الطلب',
    updateOrder: 'تحديث الطلب',
    editUser: 'تعديل المستخدم',
    deleteUser: 'حذف المستخدم',
    editExpense: 'تعديل المصروف',
    submittedForApproval: 'تم الإرسال للموافقة',

    // Buttons & Actions
    showDeleted: 'إظهار المحذوفين',
    deleted: 'محذوف',
    restore: 'استعادة',
    updating: 'جاري التحديث...',
    submitting: 'جاري الإرسال...',
    submitForApprovalBtn: 'إرسال للموافقة',
    updateExpense: 'تحديث المصروف',
    receiptsAttached: 'إيصال مرفق',
    pdfDownloaded: 'تم تحميل الملف',
    rejectionReason: 'سبب الرفض',
    noReasonProvided: 'لم يتم تحديد السبب',
    downloadPdf: 'تحميل PDF',

    // Confirmations
    confirmDeleteUser: 'هل أنت متأكد من حذف هذا المستخدم؟ لن يتمكن من تسجيل الدخول بعد الحذف.',

    // Settings placeholders
    welcomeBackPlaceholder: 'مرحباً بعودتك',
    signInPlaceholder: 'سجل دخول إلى حسابك',
    companyNamePlaceholder: 'اسم الشركة للفواتير',
    companyTaglinePlaceholder: 'مثال: حلول الرعاية الصحية المتميزة',
    invoiceEmailPlaceholder: 'invoices@company.com',
    websitePlaceholder: 'www.company.com',
    addressPlaceholder: 'عنوان الشركة الكامل للفواتير',
    thankYouPlaceholder: 'رسالة الشكر على الفواتير',
    footerPlaceholder: 'EP Group',
    selectTimezone: 'اختر المنطقة الزمنية',
    gatewayUrlPlaceholder: 'https://your-gateway.railway.app',

    // Dashboard translations
    fieldDashboard: 'لوحة العمل الميدانية',
    managerDashboard: 'لوحة المدير',
    gmDashboard: 'لوحة المدير العام',
    welcomeBack: 'مرحباً بعودتك',
    teamPerformanceOverview: 'نظرة عامة على أداء فريقك',
    companyOverview: 'نظرة عامة على الشركة',
    placeNewOrder: 'إنشاء طلب جديد',
    manageProducts: 'إدارة المنتجات',
    deleteProduct: 'حذف المنتج',
    exportPdf: 'تصدير PDF',
    createOrder: 'إنشاء طلب',
    editOrder: 'تعديل الطلب',

    // Returns & Approvals
    manageReturns: 'إدارة المرتجعات والاستردادات',
    returnDetails: 'تفاصيل المرتجع',
    rejectReturn: 'رفض المرتجع',
    orderApprovals: 'موافقات الطلبات',
    reviewPendingOrders: 'مراجعة الطلبات المعلقة',
    approveOrder: 'موافقة على الطلب',
    rejectOrder: 'رفض الطلب',

    // Expenses
    submitExpenseClaim: 'تقديم طلب مصروف',
    allTeamExpenses: 'كل مصاريف الفريق',
    specifyCategory: 'حدد الفئة...',

    // Visits form
    attendees: 'الحاضرون',
    searchForPerson: 'ابحث عن شخص لإضافته...',
    demoOrder: '📦 طلب عينات (Demo)',
    regularOrder: '🛒 طلب عادي',
    addProductBtn: 'إضافة منتج',
    demoOrderInfo: 'طلبات العينات: بحد أقصى 6 منتجات، كمية 1 لكل منتج، مجاناً',
    noProductsAdded: 'لم يتم إضافة منتجات بعد - اضغط "إضافة منتج" للبدء',
    selectProductPlaceholder: 'اختر المنتج...',
    quantity: 'كمية',
    noAttendeesRecorded: 'لم يتم تسجيل حاضرين',
    productError: 'خطأ في عرض المنتجات',
    currency: 'ج.م',

    // NEW: Plans page translations
    totalPlans: 'إجمالي الخطط',
    plannedVisits: 'زيارات مخططة',
    completed: 'مكتملة',
    completionRate: 'نسبة الإنجاز',
    noPlans: 'لا توجد خطط',
    createPlanToStart: 'قم بإنشاء خطة جديدة للبدء',
    newPlan: 'خطة جديدة',
    month: 'شهر',
    week: 'أسبوع',
    year: 'سنة',

    // NEW: Accounting page translations
    manageAccountingDesc: 'إدارة الفواتير والتحصيلات والمديونيات',
    invoices: 'الفواتير',
    payments: 'التحصيلات',
    debts: 'المديونيات',
    reports: 'التقارير',
    auditLog: 'السجل',
    installments: 'الأقساط',

    // NEW: Visits joint badge
    jointVisit: 'زيارة مشتركة',
    relatedOrder: 'الطلب المرتبط',
    exportPDF: 'تصدير PDF',

    // Performance Dashboard
    performanceReports: 'تقارير الأداء',
    repPerformanceReports: 'تقارير أداء المندوبين',
    selectMonth: 'حدد الشهر',
    allRoles: 'كل الأدوار',
    managers: 'المدراء',
    reps: 'المندوبين',
    exportReport: 'تصدير التقرير',
    refreshData: 'تحديث البيانات',
    totalUsersLabel: 'إجمالي المستخدمين',
    totalVisitsLabel: 'إجمالي الزيارات',
    totalOrdersLabel: 'إجمالي الطلبات',
    totalRevenueLabel: 'إجمالي الإيرادات',
    topReps: 'أفضل المستخدمين',
    points: 'نقطة',
    pointsLabel: 'نقطة أداء',
    visit: 'زيارة',
    order: 'طلب',
    conversion: 'تحويل',
    clinicLabel: 'عيادة',
    searchUser: 'بحث عن مستخدم...',
    mostOrders: 'الأكثر طلبات',
    mostVisits: 'الأكثر زيارات',
    highestConversion: 'أعلى تحويل',
    loadingData: 'جاري تحميل البيانات...',
    noDataToShow: 'لا توجد بيانات للعرض',
    performanceDetails: 'تفاصيل الأداء',
    showUserPerformance: 'عرض تفاصيل أداء المستخدم',
    overview: 'نظرة عامة',
    totalSales: 'إجمالي المبيعات',
    collected: 'المحصل (مدفوع)',
    remaining: 'المتبقي (ديون)',
    expensesLabel: 'المصروفات',
    approvedExpenses: 'معتمد',
    orderStatus: 'حالة الطلبات',
    fullyPaid: 'مدفوع بالكامل',
    partiallyPaid: 'مدفوع جزئياً',
    unpaid: 'غير مدفوع',
    demoSamples: 'عينات/ديمو',
    recentOrders: 'آخر الطلبات',
    recentVisits: 'آخر الزيارات',
    invoiceNumber: 'رقم الفاتورة',
    paid: 'مدفوع',
    partial: 'جزئي',
    visitType: 'النوع',
    regular: 'عادية',
    demo: 'ديمو',
    followUpVisit: 'متابعة',
    hasOrder: 'طلب',
    noOrdersInPeriod: 'لا توجد طلبات في هذه الفترة',
    periodToday: 'اليوم',
    periodWeek: 'هذا الأسبوع',
    periodMonth: 'هذا الشهر',
    periodYear: 'هذه السنة',
    vsAverage: 'مقارنة بالمتوسط',
    failedToLoadStats: 'فشل في تحميل الإحصائيات',
    generatingReport: 'جاري إنشاء التقرير...',
    reportExported: 'تم تصدير التقرير بنجاح!',
    reportExportFailed: 'فشل في تصدير التقرير',
    howScoreCalculated: 'كيف يتم حساب النقاط',
    pointsPerVisit: 'نقطة/زيارة',
    pointsPerOrder: 'نقطة/طلب',
    pointsPerConversion: 'نقطة/%',
    noMaxLimit: 'لا يوجد حد أقصى!',
    morePerformanceMorePoints: 'كلما زاد الأداء، زادت النقاط',
    example: 'مثال',

    // Users Form
    usernameLabel: 'اسم المستخدم',
    passwordLabel: 'كلمة المرور',
    fullNameLabel: 'الاسم الكامل',
    emailLabel: 'البريد الإلكتروني',
    roleLabel: 'الدور',
    managerLabel: 'المدير',
    lineLabel: 'الخط',
    areaLabel: 'المنطقة',
    createUser: 'إنشاء مستخدم',
    updateUser: 'تحديث المستخدم',
    userStats: 'إحصائيات',
    userAccess: 'الصلاحيات',
    userGps: 'تتبع GPS',
    importCsv: 'استيراد CSV',
    exportCsv: 'تصدير CSV',

    // Settings Page
    general: 'عام',
    branding: 'العلامة التجارية',
    loginPage: 'صفحة الدخول',
    printTemplates: 'قوالب الطباعة',
    footer: 'التذييل',
    system: 'النظام',
    whatsapp: 'واتساب',
    manageGlobalSettings: 'إدارة إعدادات الموقع والعلامة التجارية',
    siteTitleLabel: 'عنوان الموقع',
    tagline: 'الشعار النصي',
    contactEmail: 'البريد الإلكتروني للتواصل',
    darkMode: 'الوضع الداكن',
    saveSiteConfig: 'حفظ إعدادات الموقع',

    // Expenses Form
    expenseTypeLabel: 'نوع المصروف',
    categoryLabel: 'الفئة',
    amountLabel: 'المبلغ',
    dateTimeLabel: 'التاريخ والوقت',
    reasonDescription: 'السبب / الوصف',
    receiptAttachments: 'مرفقات الإيصال',
    clickToUpload: 'انقر لتحميل الإيصالات',
    allowedFormats: 'JPG، PNG، PDF (ملفات متعددة مسموح بها)',
    other: 'أخرى',
    noExpensesFound: 'لم يتم العثور على مصروفات',
    teamExpensesWillAppear: 'ستظهر مصروفات الفريق هنا',

    // GPS Tracking
    exportCsvBtn: 'تصدير CSV',
    refreshMap: 'تحديث الخريطة',
    activityHistory: 'سجل النشاط',
    noActivityLogs: 'لم يتم العثور على سجلات نشاط لهذا المستخدم.',
    medRep: 'مندوب طبي',

    // Approvals
    pendingOrdersLabel: 'الطلبات المعلقة',
    totalValueLabel: 'القيمة الإجمالية',
    awaitingAction: 'بانتظار الإجراء',

    // Products
    lineColon: 'الخط:',
    priceColon: 'السعر:',
    stockColon: 'المخزون:',
    units: 'وحدة',

    // Orders
    totalOrdersCard: 'إجمالي الطلبات',
    totalRevenueCard: 'إجمالي الإيرادات',
    todayLabel: 'اليوم',
    thisWeekLabel: 'هذا الأسبوع',
    ordersOverTime: 'الطلبات بمرور الوقت',
    demoOrderFree: 'طلب عينات (مجاني)',
    regularOrderLabel: 'طلب عادي',
    clinicRequired: 'العيادة *',
    orderTypeRequired: 'نوع الطلب *',
    paymentStatusRequired: 'حالة الدفع *',
    productsRequired: 'المنتجات *',
    addProductBtn: 'إضافة منتج',

    // Visits
    verifiedStatus: 'تم التحقق',
    completedStatus: 'مكتمل',
    successfulStatus: 'ناجحة',
    needsFollowUpStatus: 'تحتاج متابعة',

    // Loading Screen
    loadingApp: 'جاري تشغيل التطبيق...',
    medRepTrackingSystem: 'نظام إدارة المندوبين الطبيين',

    // Dashboard
    collections: 'التحصيلات',

    // Expenses Form
    expenseTypeLabel: 'نوع المصروف',
    categoryLabel: 'الفئة',
    amountLabel: 'المبلغ',
    dateTimeLabel: 'التاريخ والوقت',
    reasonDescription: 'السبب / الوصف',
    receiptAttachments: 'مرفقات الإيصالات',
    clickToUpload: 'انقر لرفع الإيصالات',
    allowedFormats: 'JPG، PNG، PDF (ملفات متعددة مسموحة)',
    noExpensesFound: 'لا توجد مصاريف',
    teamExpensesWillAppear: 'مصاريف الفريق ستظهر هنا',

    // GPS Tracking
    history: 'السجل',
    live: 'مباشر',

    // Approvals
    reviewPendingOrders: 'مراجعة الطلبات المعلقة',
    pendingOrders: 'الطلبات المعلقة',
    totalValue: 'القيمة الإجمالية',
    awaitingAction: 'في انتظار الإجراء',
    noPendingOrders: 'لا توجد طلبات معلقة',
    allOrdersProcessed: 'تمت معالجة جميع الطلبات',
    failedToLoadPendingOrders: 'فشل تحميل الطلبات المعلقة',
    orderApprovedSuccess: 'تمت الموافقة على الطلب بنجاح',
    failedToApproveOrder: 'فشل الموافقة على الطلب',
    provideRejectionReason: 'يرجى تقديم سبب الرفض',
    orderRejected: 'تم رفض الطلب',
    failedToRejectOrder: 'فشل رفض الطلب',

    // Products
    manageProducts: 'إدارة كتالوج المنتجات',
    productName: 'اسم المنتج',
    sku: 'رمز المنتج',
    price: 'السعر',
    stockQuantity: 'كمية المخزون',
    stock: 'المخزون',
    description: 'الوصف',
    noProducts: 'لا توجد منتجات',
    addFirstProduct: 'أضف أول منتج للكتالوج',
    createProduct: 'إنشاء منتج',
    updateProduct: 'تحديث المنتج',
    units: 'وحدة',
    deleteConfirmation: 'هل أنت متأكد من الحذف؟ لا يمكن التراجع عن هذا الإجراء.',

    // Expenses Tabs
    activeExpenses: 'الطلبات الحالية',
    expenseHistory: 'الطلبات السابقة',
    noActiveExpenses: 'لا توجد مصاريف حالية',
    pendingRejectedWillAppear: 'مصاريفك المعلقة والمرفوضة ستظهر هنا',
    noApprovedExpenses: 'لا توجد مصاريف معتمدة',
    approvedExpensesWillAppear: 'مصاريفك المعتمدة ستظهر هنا',
    noPendingApprovals: 'لا توجد طلبات معلقة للموافقة',
    allExpensesReviewed: 'تمت مراجعة جميع طلبات المصاريف',
    allTeamExpenses: 'كل مصاريف الفريق',
    submittedBy: 'مقدم من',
    viewReceipt: 'عرض الإيصال',
    approvedBy: 'تمت الموافقة بواسطة',
    on: 'في',
    by: 'بواسطة',
    noReasonProvided: 'لم يتم تقديم سبب',

    // Performance Dashboard
    userPerformance: 'أداء المستخدمين',
    paymentStatus: 'حالة المدفوعات',
    topSellingQuantity: 'الأكثر مبيعاً (كمية)',
    topRevenue: 'الأعلى إيراداً',
    mostRequestedSamples: 'أكثر العينات طلباً',
    noData: 'لا توجد بيانات',
    samples: 'عينة',
    productPerformance: 'أداء المنتجات',

    // Orders - Pending Approvals
    pendingApprovals: 'طلبات بانتظار الموافقة',
    ordersPendingApproval: 'طلب بحاجة لموافقتك',
    reviewNow: 'مراجعة الآن',

    // Orders - Payment Plan
    paymentInfo: 'معلومات الدفع',
    paidInFull: 'مدفوع بالكامل',
    partialPayment: 'دفعة جزئية',
    unpaid: 'غير مدفوع',
    bankTransfer: 'تحويل بنكي',
    eWallet: 'محفظة إلكترونية',
    cash: 'كاش',
    amountPaid: 'المبلغ المدفوع',
    remainingAmount: 'المتبقي',
    installmentPlan: 'خطة الأقساط',
    numberOfInstallments: 'عدد الأقساط',
    scheduleType: 'نوع الجدولة',
    weekly: 'أسبوعي',
    biweekly: 'كل أسبوعين',
    monthly: 'شهري',
    firstDueDate: 'تاريخ أول قسط',
    gracePeriod: 'فترة السماح',
    days: 'يوم',
    total: 'الإجمالي',
    percentage: 'نسبة',
    loading: 'جاري التحميل...',
    noReturnsFound: 'لا توجد مرتجعات',
    loadingClinicDetails: 'جاري تحميل تفاصيل العيادة...',
    clickForDetails: 'اضغط للتفاصيل',
    close: 'إغلاق',
    downloadPDF: 'تحميل PDF',
    deleteExpense: 'حذف المصروف',
    deleteExpenseConfirm: 'هل أنت متأكد من حذف هذا المصروف؟ لا يمكن التراجع عن هذا الإجراء.',
    rejectExpensePrompt: 'يرجى تقديم سبب لرفض طلب المصروف.',

    // Activity Details Dialog (SuperAdminDashboard)
    medicalRep: 'المندوب الطبي',
    visitReasonLabel: 'سبب الزيارة',
    resultLabel: 'النتيجة',
    notesLabel: 'ملاحظات',
    viewOnGoogleMaps: 'عرض على خرائط جوجل',
    createdLabel: 'أُنشئ في',
    expenseDateLabel: 'تاريخ المصروف',
    invalidDate: 'تاريخ غير صالح',
    naLabel: 'غير متوفر',
    productsCount: 'المنتجات',

    // Users page
    passwordMinimum: 'الحد الأدنى 6 أحرف. اتركه فارغاً إذا لم ترغب بتغيير كلمة المرور.',

    // Plans - Missing Arabic translations
    createNewPlan: 'إنشاء خطة جديدة',
    savePlan: 'حفظ الخطة',
    additionalPlanNotes: 'ملاحظات إضافية للخطة...',
    noVisitsAddedYet: 'لم تتم إضافة زيارات بعد',
    totalPlans: 'إجمالي الخطط',
    plannedVisits: 'الزيارات المخططة',
    completionRate: 'نسبة الإنجاز',
    noPlans: 'لا توجد خطط',
    createPlanToStart: 'أنشئ خطة جديدة للبدء',
    newPlan: 'خطة جديدة',
    month: 'شهر',
    week: 'أسبوع',
    year: 'سنة',
    weekNumber: 'رقم الأسبوع',
    weeklyGoal: 'الهدف الأسبوعي',
    priority: 'الأولوية',
    priorityHigh: 'عالية',
    priorityMedium: 'متوسطة',
    priorityLow: 'منخفضة',

    // Roles - Missing Arabic labels
    accountant: 'محاسب',

    // Loading
    loading: 'جاري التحميل...',
    loadingApp: 'جاري تحميل التطبيق...',
  },

  en: {
    // Auth
    medtrack: 'Medical Representative Tracking System',
    medtrackShort: 'MedTrack',
    username: 'Username',
    password: 'Password',
    signIn: 'Sign In',
    signingIn: 'Signing in...',
    logout: 'Logout',
    demoCredentials: 'Demo credentials will be provided by admin',
    enterUsername: 'Enter your username',
    enterPassword: 'Enter your password',

    // Common
    dashboard: 'Dashboard',
    clinics: 'Clinics',
    visits: 'Visits',
    plans: 'Plans',
    managePlansDesc: 'Manage monthly visit plans for clinics',
    orders: 'Orders',
    expenses: 'Expenses',
    users: 'Users',
    products: 'Products',
    approvals: 'Approvals',
    gpsTracking: 'GPS Tracking',
    activityMap: 'Activity Map',
    activityHistory: 'Activity History',
    exportCsv: 'Export CSV',
    inactive: 'Inactive',
    startDate: 'Start Date',
    endDate: 'End Date',
    apply: 'Apply',
    clear: 'Clear',
    inactiveUsersAlert: 'Inactive Users Alert',
    inactivityThreshold: 'Inactivity threshold',
    noActivityLogs: 'No activity logs found for this user.',
    noGpsData: 'No GPS data captured',
    toggleDarkLight: 'Toggle dark/light theme',
    saving: 'Saving...',
    saveSiteConfiguration: 'Save Site Configuration',
    gpsVerified: 'GPS Verified',
    settings: 'Settings',
    returns: 'Returns',
    accounting: 'Accounting',
    inventory: 'Inventory',
    performance: 'Performance',
    manageClinicInfo: 'Manage clinic information',
    trackClinicVisits: 'Track clinic visits',
    manageOrders: 'Manage clinic orders',
    trackExpenses: 'Track and manage expenses',
    manageTeam: 'Manage team members and access',
    monitorLocations: 'Monitor field representative locations',
    availableClinics: 'Available Clinics',
    totalVisits: 'Total Visits',
    ordersCompleted: 'Orders Completed',
    pendingApproval: 'Pending Approval',
    logVisit: 'Log Visit',
    recordClinicVisit: 'Record clinic visit',
    addExpense: 'Add Expense',
    submitExpenseClaim: 'Submit expense claim',
    registerNewClinic: 'Register new clinic',
    youHaveOrdersWaiting: 'You have',
    ordersWaitingApproval: 'orders waiting for approval',
    welcome: 'Welcome',
    quickActions: 'Quick Actions',
    manageClinics: 'Manage Clinics',
    viewVisits: 'View Visits',
    manageUsers: 'Manage Users',

    // Roles
    superAdmin: 'Super Admin',
    gm: 'General Manager',
    manager: 'Manager',
    medicalRep: 'Medical Rep',
    accountant: 'Accountant',
    lastLogin: 'Last login',
    noLine: 'No Line',
    noArea: 'No Area',

    // Dashboard titles
    superAdminDashboard: 'Super Admin Dashboard',
    gmDashboard: 'General Manager Dashboard',
    managerDashboard: 'Manager Dashboard',
    fieldDashboard: 'Field Dashboard',

    // Stats
    organizations: 'Organizations',
    totalUsers: 'Total Users',
    totalClinics: 'Total Clinics',
    totalVisits: 'Total Visits',
    teamMembers: 'Team Members',
    activeTracking: 'Active Tracking',

    // Actions
    create: 'Create',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    submit: 'Submit',
    update: 'Update',
    close: 'Close',

    // Organizations
    newOrganization: 'New Organization',
    createOrganization: 'Create Organization',
    organizationName: 'Organization Name',
    address: 'Address',
    phone: 'Phone',
    manageAllOrgs: 'Manage all organizations and users',
    noOrganizations: 'No organizations yet',
    createFirstOrg: 'Create one to get started',

    // Clinics
    addClinic: 'Add Clinic',
    clinicName: 'Clinic Name',
    doctorName: 'Doctor Name',
    specialty: 'Specialty',
    email: 'Email',
    gpsLocation: 'GPS Location',
    captureLocation: 'Capture Current Location',
    locationCaptured: 'Location captured',
    creating: 'Creating...',
    noClinics: 'No clinics yet',
    addFirstClinic: 'Add your first clinic to get started',
    // Clinic Dialog - NEW
    editClinic: 'Edit Clinic',
    registerNewClinic: 'Register New Clinic',
    editClinicData: 'Edit clinic data',
    completeRequiredInfo: 'Complete all required information',
    locationOnMap: 'Location on Map',
    locatingPosition: 'Locating position...',
    locationSet: 'Location set:',
    clinicData: 'Clinic Data',
    line: 'Line',
    area: 'Area',
    doctorPhone: 'Doctor Phone',
    clinicPhone: 'Clinic Phone',
    classifications: 'Classifications',
    clinicClassification: 'Clinic Classification',
    creditClassification: 'Credit Classification',
    saving: 'Saving...',
    updateClinic: 'Update Clinic',
    accountStatement: 'Account Statement',
    comingSoon: 'Coming Soon',
    invoices: 'Invoices',
    totalOrders: 'Total Orders',
    totalVisits: 'Total Visits',
    team: 'Team',
    overview: 'Overview',
    clinicInformation: 'Clinic Information',
    doctor: 'Doctor',
    classification: 'Classification',
    class: 'Class',
    topOrderedProducts: 'Top Ordered Products',
    units: 'units',
    authorizedMedicalReps: 'Authorized Medical Reps',
    authorizedRepsDescription: 'Medical representatives assigned to the same line can visit this clinic',
    noAuthorizedReps: 'No authorized reps found',
    completed: 'Completed',
    pending_approval: 'Pending Approval',

    // Clinics Form - Additional translations
    accuracyUltra: 'Ultra Accurate',
    accuracyHigh: 'High Accuracy',
    accuracyMedium: 'Medium Accuracy',
    accuracyLow: 'Low Accuracy',
    nearbyClinicsWarning: '{count} clinic(s) very close to this location!',
    ensureNewClinic: 'Make sure this is a new clinic and not already registered',
    dismissWarning: 'Dismiss Warning',
    searchAddress: 'Search Address',
    addressSearchPlaceholder: 'Type street name or address to search...',
    mapInstructions: 'Click or drag the pin to set location',
    locationInstructions: 'Click the 📍 button on the map to set your location • Or click anywhere to place the pin manually',
    selectLine: 'Select Line',
    selectArea: 'Select Area',
    detailedAddress: 'Detailed Address',
    addressPlaceholder: 'Full address with landmarks',
    clinicNamePlaceholder: 'Enter clinic name',
    doctorNamePlaceholder: 'Dr. Full Name',
    specialtyPlaceholder: 'e.g.: Cardiology, Pediatrics',
    doctorPhonePlaceholder: 'Doctor direct number',
    clinicPhonePlaceholder: 'Main clinic number',
    classificationExcellent: 'Excellent',
    classificationGood: 'Good',
    classificationNormal: 'Normal',
    creditExcellent: 'Excellent',
    creditGood: 'Good',
    creditDanger: 'Danger',
    classificationNotes: 'Classification Notes',
    classificationNotesPlaceholder: 'Notes about classification criteria...',
    registrationNotes: 'Registration Notes',
    registrationNotesPlaceholder: 'Additional information for registration...',
    registerClinic: 'Register Clinic',
    noClinicsRegistered: 'No clinics registered',
    startRegisteringClinics: 'Start by registering your first clinic',
    confirmDeleteClinic: 'Are you sure you want to delete this clinic?',
    clinicDeletedSuccess: 'Clinic deleted successfully',
    clinicDeleteFailed: 'Failed to delete clinic',
    clinicUpdatedSuccess: 'Clinic updated successfully',
    clinicCreatedSuccess: 'Clinic registered successfully',
    selectLineAndArea: 'Please select a line and area',
    clinicSaveFailed: 'Failed to save clinic',
    failedToLoadClinics: 'Failed to load clinics',
    failedToLoadLines: 'Failed to load lines',
    failedToLoadAreas: 'Failed to load areas',
    locationTrackingStopped: 'Location tracking stopped',
    gpsLocationError: 'Location tracking error - please move the pin manually',
    gpsLocationFailed: 'Failed to get location - make sure GPS is enabled',
    metricMeters: 'meters',
    moreClinics: '+ {count} more clinic(s)',
    areaAutoSelected: 'Area auto-selected',
    gpsHighAccuracy: 'Getting your location with high accuracy...',
    gpsSearchingSignal: 'Searching for GPS signal... may take a few seconds',
    gpsCurrentAccuracy: 'Current accuracy: {accuracy}m - improving...',
    gpsExcellentAccuracy: 'Location set with excellent accuracy: {accuracy} meters 🎯',
    gpsImprovingBackground: 'Current accuracy: {accuracy}m - improving in background...',
    myLocationButton: 'Get my current location',

    // Visits
    logVisit: 'Log Visit',
    clinic: 'Clinic',
    selectClinic: 'Select clinic',
    verifyLocation: 'Verify Location',
    updateLocation: 'Update Location',
    notes: 'Notes',
    addVisitNotes: 'Add any notes about the visit...',
    logging: 'Logging...',
    verified: 'Verified',
    pending: 'Pending',
    locationVerified: 'Location verified within 1km',
    locationCapturedNotVerified: 'Location captured but not within 1km range',
    noVisits: 'No visits logged yet',
    startTracking: 'Start tracking your clinic visits',
    visitsReference: 'Visits Reference',
    manageFieldVisits: 'Manage and track your field visits',
    editVisit: 'Edit Visit',
    visitDetails: 'Visit Details',
    noVisitsRecorded: 'No visits recorded',
    logFirstVisit: 'Log your first clinic visit to see it here.',
    visitReason: 'Visit Reason',
    visitResult: 'Visit Result',
    attendees: 'Attendees',
    samplesProvided: 'Samples Provided',
    addSample: 'Add Sample',
    followUpDate: 'Follow-up Date',
    visitRating: 'Visit Rating',
    outcome: 'Outcome',
    clickForDetails: 'CLICK FOR DETAILS',
    processing: 'Processing...',
    deleteVisitRecord: 'Delete Visit Record',
    confirmDeleteVisit: 'Are you sure? This will remove the visit log from the system permanently.',
    updateVisitLog: 'Update Visit Log',
    logNewVisit: 'Log New Visit',
    successful: 'Successful',
    doctorInterested: 'Doctor Interested',
    needsFollowUp: 'Needs Follow Up',
    personAbsent: 'Person Absent',
    followUp: 'Maint. / Follow Up',
    newProductLaunch: 'New Product Launch',
    productDemo: 'Product Demo',
    placeOrderReason: 'Place Order',
    issueResolution: 'Issue Resolution',
    clinicOpening: 'Clinic Opening',
    noneLogged: 'None logged',
    unknownClinic: 'Unknown Clinic',
    free: 'FREE',
    discountApplied: 'Discount Applied',
    rejectionReasonPrompt: 'Please provide a reason for rejecting this order. This will be sent to the medical rep.',
    confirmRejection: 'Confirm Rejection',
    verifiedVisit: 'Verified Visit',
    gridView: 'Grid View',
    listView: 'List View',
    detailedView: 'Detailed View',
    result: 'Result',
    reason: 'Reason',
    rating: 'Rating',
    selectReason: 'Select reason',
    selectResult: 'Select result',
    product: 'Product',
    qty: 'Qty',
    keyTakeaways: 'Key takeaways, doctor feedback, etc.',
    notes: 'Notes',
    notesPlaceholder: 'Notes and important points from the visit...',
    outcome: 'Outcome',
    verified: 'Verified',
    verifiedVisit: 'Verified Visit',
    status_completed: 'Completed',
    status_planned: 'Planned',
    status_cancelled: 'Cancelled',
    status_pending: 'Pending',

    // Orders
    totalOrders: 'Total Orders',
    totalRevenue: 'Total Revenue',
    today: 'Today',
    thisWeek: 'This Week',
    timeline: 'Timeline',
    comments: 'Comments',
    discountOptional: 'Discount (Optional)',
    discountType: 'Discount Type',
    discountValue: 'Discount Value',
    discountReason: 'Discount Reason',
    subtotal: 'Subtotal',
    discount: 'Discount',
    rejectionReason: 'Rejection Reason',
    downloadInvoice: 'Download Invoice',
    duplicate: 'Duplicate',
    orderAgain: 'Order Again',
    restore: 'Restore',
    createOrder: 'Create Order',
    products: 'Products',
    addProduct: 'Add Product',
    orderType: 'Order Type',
    regularOrder: 'Regular Order',
    demoOrder: 'Demo (Free Samples)',
    demoOrderNote: 'Demo orders: Maximum 6 products, 1 quantity each, Free of charge',
    productName: 'Product name',
    quantity: 'Quantity',
    price: 'Price',
    totalAmount: 'Total Amount',
    status: 'Status',
    draft: 'Draft',
    submitted: 'Submitted',
    approved: 'Approved',
    delivered: 'Delivered',
    noOrders: 'No orders yet',
    createFirstOrder: 'Create your first order',
    noTimelineHistory: 'No timeline history yet',
    noComments: 'No comments yet',
    noUsers: 'No users yet',
    noLinesYet: 'No lines created yet',
    noAreasYet: 'No areas created yet',
    addLine: 'Add Line',
    editLine: 'Edit Line',
    lineName: 'Line Name',
    createLine: 'Create Line',
    updateLine: 'Update Line',
    addArea: 'Add Area',
    editArea: 'Edit Area',
    areaName: 'Area Name',
    selectLine: 'Select line',
    createArea: 'Create Area',
    updateArea: 'Update Area',
    systemHealth: 'System Health',
    monitorDbStatus: 'Monitor database and system status',
    lines: 'Lines',
    manageCompanyLines: 'Manage company lines',
    areas: 'Areas',
    manageGeoAreas: 'Manage geographical areas',

    // Expenses
    addExpense: 'Add Expense',
    expenseType: 'Expense Type',
    amount: 'Amount',
    date: 'Date',
    description: 'Description',
    receiptUrl: 'Receipt URL',
    addExpenseDetails: 'Add details about this expense...',
    submitting: 'Submitting...',
    submitExpense: 'Submit Expense',
    viewReceipt: 'View Receipt',
    noExpenses: 'No expenses yet',
    submitFirstExpense: 'Submit your first expense claim',
    // Expense Categories
    expenseCategory: 'Category',
    categoryTravel: 'Travel',
    categoryMeals: 'Meals',
    categoryAccommodation: 'Accommodation',
    categoryTransportation: 'Transportation',
    categorySupplies: 'Supplies',
    categoryCommunication: 'Communication',
    categoryEntertainment: 'Entertainment',
    categoryMedical: 'Medical',
    categoryOther: 'Other',
    // Expense Approval
    pendingApproval: 'Pending Approval',
    myExpenses: 'My Expenses',
    approveExpense: 'Approve Expense',
    rejectExpense: 'Reject Expense',
    rejectionReason: 'Rejection Reason',
    expenseApproved: 'Expense approved',
    expenseRejected: 'Expense rejected',
    uploadReceipt: 'Upload Receipt',
    receiptUploaded: 'Receipt uploaded',
    submitForApproval: 'Submit for Approval',
    noPendingApprovals: 'No pending approvals',
    allExpensesReviewed: 'All expense claims have been reviewed',
    submittedBy: 'Submitted by',

    // Users
    addUser: 'Add User',
    fullName: 'Full Name',
    role: 'Role',
    organization: 'Organization',
    selectOrganization: 'Select organization',
    access: 'Access',
    gps: 'GPS',
    noUsers: 'No users yet',
    addTeamMembers: 'Add team members to get started',

    // GPS
    gpsTrackingDisabled: 'GPS Tracking Disabled',
    enableToLog: 'Enable to log your field activities',
    enableGPS: 'Enable GPS',
    gpsTrackingActive: 'GPS Tracking Active',
    location: 'Location',
    latitude: 'Latitude',
    longitude: 'Longitude',
    accuracy: 'Accuracy',
    selectMedicalRep: 'Select Medical Representative',
    currentUser: 'Current User',
    latestLocation: 'Latest Location',
    locationHistory: 'Location History',
    noGpsLogs: 'No GPS logs found',
    locationTrackingWillAppear: 'Location tracking will appear here when the user enables GPS',
    mapView: 'Map View',
    mapIntegration: 'Map Integration',
    viewOnGoogleMaps: 'View on Google Maps',
    activity: 'Activity',

    // Quick Actions
    quickActions: 'Quick Actions',
    manageClinics: 'Manage Clinics',
    viewVisits: 'View Visits',
    manageUsers: 'Manage Users',
    registerClinic: 'Register new clinic',
    recordVisit: 'Record clinic visit',
    placeOrder: 'Place new order',
    submitExpenseClaim: 'Submit expense claim',
    controlAccess: 'Control access and permissions',
    monitorReps: 'Monitor field representatives',
    trackActivities: 'Track visit activities',

    // Messages
    loginSuccessful: 'Login successful',
    loginFailed: 'Login failed',
    createdSuccessfully: 'Created successfully',
    updatedSuccessfully: 'Updated successfully',
    deletedSuccessfully: 'Deleted successfully',
    operationFailed: 'Operation failed',
    gpsEnabled: 'GPS tracking enabled',
    gpsDisabled: 'GPS tracking disabled',
    locationCapturedSuccess: 'Location captured!',

    // Status
    active: 'Active',
    inactive: 'Inactive',

    // Welcome
    welcomeBack: 'Welcome back',
    overviewActivities: "Overview of your organization's activities",
    manageTeamMonitor: 'Manage your team and monitor activities',

    // Search
    searchPlaceholder: 'Search clinics, users, orders...',
    noResultsFor: 'No results for',

    // Dashboard - NEW
    adminDashboard: 'Admin Dashboard',
    systemOverview: 'System overview and performance metrics',
    pendingOrders: 'Pending Orders',
    pendingExpenses: 'Pending Expenses',
    activeReps: 'Active Reps',
    today: 'Today',
    thisWeek: 'This Week',
    totalRevenue: 'Total Revenue',
    fromApprovedOrders: 'From approved orders',
    weeklyTrends: 'Weekly Trends',
    topPerformers: 'Top Performers',
    dailyActivity: 'Daily Activity',
    recentActivities: 'Recent Activities',
    noDataAvailable: 'No data available',
    noRecentActivities: 'No recent activities',

    // Date formatting
    naLabel: 'N/A',
    invalidDate: 'Invalid Date',

    // Settings - NEW
    siteConfiguration: 'Site Configuration',
    siteTitle: 'Site Title',
    logoUrl: 'Logo URL',
    gpsSettings: 'GPS Settings',
    systemHealth: 'System Health',
    sessionsManagement: 'Sessions Management',
    customFields: 'Custom Fields',
    dataExport: 'Data Export',
    dataImport: 'Data Import',
    saveSettings: 'Save Settings',
    uploadLogo: 'Upload Logo',
    exportData: 'Export Data',
    importData: 'Import Data',
    terminateSession: 'Terminate Session',
    activeSessions: 'Active Sessions',

    // Expenses Tabs - NEW
    myExpensesTab: 'My Expenses',
    pendingApprovalTab: 'Pending Approval',
    allExpensesTab: 'All Expenses',
    addNewExpense: 'Add New Expense',
    expenseAmount: 'Expense Amount',

    // Orders - NEW
    analytics: 'Analytics',
    filters: 'Filters',
    exportPdf: 'Export PDF',
    allOrders: 'All Orders',
    allTeamOrders: 'All Team Orders',
    orderDetails: 'Order Details',
    processing: 'Processing',
    shipped: 'Shipped',
    rejected: 'Rejected',
    duplicate: 'Duplicate',
    orderAgain: 'Order Again',
    restore: 'Restore',
    invoiceDownloaded: 'Invoice Downloaded',

    // New Features - Filters & Plans
    progress: 'Progress',
    weekNumber: 'Week Number',
    weeklyGoal: 'Weekly Goal',
    priority: 'Priority',
    priorityHigh: 'High',
    priorityMedium: 'Medium',
    priorityLow: 'Low',
    conflictDetected: 'Conflict Detected',
    conflictSameClinic: 'Two visits to same clinic on same day',
    conflictMultipleVisits: 'Multiple visits on same day',
    clearFilters: 'Clear Filters',
    searchPlaceholder: 'Search by clinic or notes...',
    showing: 'Showing',
    outOf: 'out of',
    dateFrom: 'Date From',
    dateTo: 'Date To',
    allClinics: 'All Clinics',
    allReasons: 'All Reasons',
    productivityToday: 'Today\'s Productivity',
    dailyGoal: 'Daily Goal',
    visitsCompleted: 'Visits Completed',
    ordersToday: 'Today\'s Orders',

    // NEW: Missing translations
    // Placeholders
    selectProduct: 'Select product',
    selectType: 'Select type',
    discountReason: 'Why is this discount being applied?',
    addNotes: 'Add any notes...',
    searchProducts: 'Search by product name or order ID...',
    allStatuses: 'All Statuses',
    addComment: 'Add a comment...',
    selectLine: 'Select line',
    productExample: 'e.g., Vitamin C Serum',
    skuExample: 'e.g., VIT-C-001',
    productDescription: 'Product description...',
    noManager: 'No Manager (User is a Manager)',
    selectLineOptional: 'Select line (optional)',
    selectAreaOptional: 'Select area (optional)',
    leaveEmptyPassword: 'Leave empty to keep current password',
    expenseExample: 'e.g., Gas, Lunch, Hotel',
    selectCategory: 'Select category',
    expenseExplain: 'Explain the purpose of this expense...',
    enterRejection: 'Enter rejection reason...',
    enterReasonRejection: 'Enter reason for rejection...',
    rejectionExample: 'e.g., Discount too high, Product out of stock...',
    selectUser: 'Select User',
    selectStyle: 'Select style',
    samplesProvided: 'Samples Provided',
    editVisit: 'Edit Visit',
    close: 'Close',
    unknownUser: 'Unknown User',

    // Titles & Headers
    editProduct: 'Edit Product',
    editOrder: 'Edit Order',
    updateOrder: 'Update Order',
    editUser: 'Edit User',
    deleteUser: 'Delete User',
    editExpense: 'Edit Expense',
    submittedForApproval: 'Submitted for Approval',

    // Buttons & Actions
    showDeleted: 'Show Deleted',
    deleted: 'Deleted',
    restore: 'Restore',
    updating: 'Updating...',
    submitting: 'Submitting...',
    submitForApprovalBtn: 'Submit for Approval',
    updateExpense: 'Update Expense',
    receiptsAttached: 'receipt attached',
    pdfDownloaded: 'File downloaded',
    rejectionReason: 'Rejection Reason',
    noReasonProvided: 'No reason provided',
    downloadPdf: 'Download PDF',

    // Confirmations
    confirmDeleteUser: 'Are you sure you want to delete this user? They will no longer be able to log in.',

    // Settings placeholders
    welcomeBackPlaceholder: 'Welcome Back',
    signInPlaceholder: 'Sign in to your account',
    companyNamePlaceholder: 'Company name on invoices',
    companyTaglinePlaceholder: 'e.g., Quality Healthcare Solutions',
    invoiceEmailPlaceholder: 'invoices@company.com',
    websitePlaceholder: 'www.company.com',
    addressPlaceholder: 'Full company address for invoices',
    thankYouPlaceholder: 'Thank you message on invoices',
    footerPlaceholder: 'EP Group',
    selectTimezone: 'Select timezone',
    gatewayUrlPlaceholder: 'https://your-gateway.railway.app',

    // Dashboard translations
    fieldDashboard: 'Field Dashboard',
    managerDashboard: 'Manager Dashboard',
    gmDashboard: 'General Manager Dashboard',
    welcomeBack: 'Welcome back',
    teamPerformanceOverview: 'Overview of your team\'s performance',
    companyOverview: 'Overview of company activities',
    placeNewOrder: 'Place new order',
    manageProducts: 'Manage product catalog',
    deleteProduct: 'Delete Product',
    exportPdf: 'Export PDF',
    createOrder: 'Create Order',
    editOrder: 'Edit Order',

    // Returns & Approvals
    manageReturns: 'Manage order returns and refunds',
    returnDetails: 'Return Details',
    rejectReturn: 'Reject Return',
    orderApprovals: 'Order Approvals',
    reviewPendingOrders: 'Review and approve pending orders',
    approveOrder: 'Approve Order',
    rejectOrder: 'Reject Order',

    // Expenses
    submitExpenseClaim: 'Submit Expense Claim',
    allTeamExpenses: 'All Team Expenses',
    specifyCategory: 'Specify category...',

    // Visits form
    attendees: 'Attendees',
    searchForPerson: 'Search for a person to add...',
    demoOrder: '📦 Demo Order',
    regularOrder: '🛒 Regular Order',
    addProductBtn: 'Add Product',
    demoOrderInfo: 'Demo orders: Max 6 products, 1 quantity each, free of charge',
    noProductsAdded: 'No products added yet - click "Add Product" to start',
    selectProductPlaceholder: 'Select product...',
    quantity: 'Qty',
    noAttendeesRecorded: 'No attendees recorded',
    productError: 'Error displaying products',
    currency: 'EGP',
    viewFullOrder: 'View Full Order',
    writeComment: 'Write a comment...',
    noCommentsYet: 'No comments yet',
    send: 'Send',
    orderId: 'Order #',
    moreProducts: 'more products...',
    createNewPlan: 'Create New Plan',
    savePlan: 'Save Plan',
    remainingDebt: 'Remaining Debt',
    totalCollections: 'Total Collections',
    clickToViewDetails: 'Click to View Details',
    clickToViewOrder: 'Click to View Order',
    allResults: 'All Results',

    // NEW: Plans page translations
    totalPlans: 'Total Plans',
    plannedVisits: 'Planned Visits',
    completed: 'Completed',
    completionRate: 'Completion Rate',
    noPlans: 'No Plans',
    createPlanToStart: 'Create a new plan to get started',
    newPlan: 'New Plan',
    month: 'Month',
    week: 'Week',
    year: 'Year',

    // NEW: Accounting page translations
    manageAccountingDesc: 'Manage invoices, payments, and debts',
    invoices: 'Invoices',
    payments: 'Payments',
    debts: 'Debts',
    reports: 'Reports',
    auditLog: 'Log',
    installments: 'Installments',

    // NEW: Visits joint badge
    jointVisit: 'Joint Visit',
    relatedOrder: 'Related Order',
    exportPDF: 'Export PDF',

    // Performance Dashboard
    performanceReports: 'Performance Reports',
    repPerformanceReports: 'Rep Performance Reports',
    selectMonth: 'Select Month',
    allRoles: 'All Roles',
    managers: 'Managers',
    reps: 'Representatives',
    exportReport: 'Export Report',
    refreshData: 'Refresh Data',
    totalUsersLabel: 'Total Users',
    totalVisitsLabel: 'Total Visits',
    totalOrdersLabel: 'Total Orders',
    totalRevenueLabel: 'Total Revenue',
    topReps: 'Top Representatives',
    points: 'points',
    pointsLabel: 'Performance Points',
    visit: 'visit',
    order: 'order',
    conversion: 'conversion',
    clinicLabel: 'clinic',
    searchUser: 'Search for user...',
    mostOrders: 'Most Orders',
    mostVisits: 'Most Visits',
    highestConversion: 'Highest Conversion',
    loadingData: 'Loading data...',
    noDataToShow: 'No data to display',
    performanceDetails: 'Performance Details',
    showUserPerformance: 'View user performance details',
    overview: 'Overview',
    totalSales: 'Total Sales',
    collected: 'Collected (Paid)',
    remaining: 'Remaining (Debts)',
    expensesLabel: 'Expenses',
    approvedExpenses: 'Approved',
    orderStatus: 'Order Status',
    fullyPaid: 'Fully Paid',
    partiallyPaid: 'Partially Paid',
    unpaid: 'Unpaid',
    demoSamples: 'Demo/Samples',
    recentOrders: 'Recent Orders',
    recentVisits: 'Recent Visits',
    invoiceNumber: 'Invoice Number',
    paid: 'Paid',
    partial: 'Partial',
    visitType: 'Type',
    regular: 'Regular',
    demo: 'Demo',
    followUpVisit: 'Follow Up',
    hasOrder: 'Order',
    noOrdersInPeriod: 'No orders in this period',
    periodToday: 'Today',
    periodWeek: 'This Week',
    periodMonth: 'This Month',
    periodYear: 'This Year',
    vsAverage: 'vs Average',
    failedToLoadStats: 'Failed to load statistics',
    generatingReport: 'Generating report...',
    reportExported: 'Report exported successfully!',
    reportExportFailed: 'Failed to export report',
    howScoreCalculated: 'How points are calculated',
    pointsPerVisit: 'points/visit',
    pointsPerOrder: 'points/order',
    pointsPerConversion: 'points/%',
    noMaxLimit: 'No maximum limit!',
    morePerformanceMorePoints: 'More performance = more points',
    example: 'Example',

    // Users Form
    usernameLabel: 'Username',
    passwordLabel: 'Password',
    fullNameLabel: 'Full Name',
    emailLabel: 'Email',
    roleLabel: 'Role',
    managerLabel: 'Manager',
    lineLabel: 'Line',
    areaLabel: 'Area',
    createUser: 'Create User',
    updateUser: 'Update User',
    userStats: 'Stats',
    userAccess: 'Access',
    userGps: 'GPS Tracking',
    importCsv: 'Import CSV',
    exportCsv: 'Export CSV',

    // Settings Page
    general: 'General',
    branding: 'Branding',
    loginPage: 'Login Page',
    printTemplates: 'Print Templates',
    footer: 'Footer',
    system: 'System',
    whatsapp: 'WhatsApp',
    manageGlobalSettings: 'Manage global site settings and branding',
    siteTitleLabel: 'Site Title',
    tagline: 'Tagline',
    contactEmail: 'Contact Email',
    darkMode: 'Dark Mode',
    saveSiteConfig: 'Save Site Configuration',

    // Expenses Form
    expenseTypeLabel: 'Expense Type',
    categoryLabel: 'Category',
    amountLabel: 'Amount',
    dateTimeLabel: 'Date & Time',
    reasonDescription: 'Reason / Description',
    receiptAttachments: 'Receipt Attachments',
    clickToUpload: 'Click to upload receipts',
    allowedFormats: 'JPG, PNG, PDF (multiple files allowed)',
    other: 'Other',
    noExpensesFound: 'No expenses found',
    teamExpensesWillAppear: 'Team expenses will appear here',

    // GPS Tracking
    exportCsvBtn: 'Export CSV',
    refreshMap: 'Refresh Map',
    activityHistory: 'Activity History',
    noActivityLogs: 'No activity logs found for this user.',
    medRep: 'Med Rep',

    // Approvals
    pendingOrdersLabel: 'Pending Orders',
    totalValueLabel: 'Total Value',
    awaitingAction: 'Awaiting Action',

    // Products
    lineColon: 'Line:',
    priceColon: 'Price:',
    stockColon: 'Stock:',
    units: 'units',

    // Orders
    totalOrdersCard: 'Total Orders',
    totalRevenueCard: 'Total Revenue',
    todayLabel: 'Today',
    thisWeekLabel: 'This Week',
    ordersOverTime: 'Orders over time',
    demoOrderFree: 'Demo Order (Free)',
    regularOrderLabel: 'Regular Order',
    clinicRequired: 'Clinic *',
    orderTypeRequired: 'Order Type *',
    paymentStatusRequired: 'Payment Status *',
    productsRequired: 'Products *',
    addProductBtn: 'Add Product',

    // Visits
    verifiedStatus: 'Verified',
    completedStatus: 'Completed',
    successfulStatus: 'Successful',
    needsFollowUpStatus: 'Needs Follow Up',

    // Loading Screen
    loadingApp: 'Loading application...',
    medRepTrackingSystem: 'Medical Representative Tracking System',

    // Dashboard
    collections: 'Collections',

    // Expenses Form
    expenseTypeLabel: 'Expense Type',
    categoryLabel: 'Category',
    amountLabel: 'Amount',
    dateTimeLabel: 'Date & Time',
    reasonDescription: 'Reason / Description',
    receiptAttachments: 'Receipt Attachments',
    clickToUpload: 'Click to upload receipts',
    allowedFormats: 'JPG, PNG, PDF (multiple files allowed)',
    noExpensesFound: 'No expenses found',
    teamExpensesWillAppear: 'Team expenses will appear here',

    // GPS Tracking
    history: 'History',
    live: 'Live',

    // Approvals
    reviewPendingOrders: 'Review pending orders',
    pendingOrders: 'Pending Orders',
    totalValue: 'Total Value',
    awaitingAction: 'Awaiting Action',
    noPendingOrders: 'No pending orders',
    allOrdersProcessed: 'All orders have been processed',
    failedToLoadPendingOrders: 'Failed to load pending orders',
    orderApprovedSuccess: 'Order approved successfully',
    failedToApproveOrder: 'Failed to approve order',
    provideRejectionReason: 'Please provide a rejection reason',
    orderRejected: 'Order rejected',
    failedToRejectOrder: 'Failed to reject order',

    // Products
    manageProducts: 'Manage product catalog',
    productName: 'Product Name',
    sku: 'SKU',
    price: 'Price',
    stockQuantity: 'Stock Quantity',
    stock: 'Stock',
    description: 'Description',
    noProducts: 'No products yet',
    addFirstProduct: 'Add your first product to the catalog',
    createProduct: 'Create Product',
    updateProduct: 'Update Product',
    units: 'units',
    deleteConfirmation: 'Are you sure? This action cannot be undone.',

    // Expenses Tabs
    activeExpenses: 'Active',
    expenseHistory: 'History',
    noActiveExpenses: 'No active expenses',
    pendingRejectedWillAppear: 'Your pending and rejected expenses will appear here',
    noApprovedExpenses: 'No approved expenses',
    approvedExpensesWillAppear: 'Your approved expenses will appear here',
    noPendingApprovals: 'No pending approvals',
    allExpensesReviewed: 'All expense claims have been reviewed',
    allTeamExpenses: 'All Team Expenses',
    submittedBy: 'Submitted by',
    viewReceipt: 'View Receipt',
    approvedBy: 'Approved by',
    on: 'on',
    by: 'by',
    noReasonProvided: 'No reason provided',

    // Performance Dashboard
    userPerformance: 'User Performance',
    paymentStatus: 'Payment Status',
    topSellingQuantity: 'Top Selling (Quantity)',
    topRevenue: 'Top Revenue',
    mostRequestedSamples: 'Most Requested Samples',
    noData: 'No data',
    samples: 'samples',
    productPerformance: 'Product Performance',

    // Orders - Pending Approvals
    pendingApprovals: 'Pending Approvals',
    ordersPendingApproval: 'orders pending your approval',
    reviewNow: 'Review Now',

    // Orders - Payment Plan
    paymentInfo: 'Payment Info',
    paidInFull: 'Paid in Full',
    partialPayment: 'Partial Payment',
    unpaid: 'Unpaid',
    bankTransfer: 'Bank Transfer',
    eWallet: 'E-Wallet',
    cash: 'Cash',
    amountPaid: 'Amount Paid',
    remainingAmount: 'Remaining',
    installmentPlan: 'Installment Plan',
    numberOfInstallments: 'Number of Installments',
    scheduleType: 'Schedule Type',
    weekly: 'Weekly',
    biweekly: 'Bi-weekly',
    monthly: 'Monthly',
    firstDueDate: 'First Due Date',
    gracePeriod: 'Grace Period',
    days: 'days',
    total: 'Total',
    percentage: 'percentage',
    loading: 'Loading...',
    noReturnsFound: 'No returns found',
    loadingClinicDetails: 'Loading clinic details...',
    clickForDetails: 'Click for Details',
    close: 'Close',
    downloadPDF: 'Download PDF',
    deleteExpense: 'Delete Expense',
    deleteExpenseConfirm: 'Are you sure you want to delete this expense? This action cannot be undone.',
    rejectExpensePrompt: 'Please provide a reason for rejecting this expense claim.',

    // Activity Details Dialog (SuperAdminDashboard)
    medicalRep: 'Medical Rep',
    visitReasonLabel: 'Visit Reason',
    resultLabel: 'Result',
    notesLabel: 'Notes',
    viewOnGoogleMaps: 'View on Google Maps',
    createdLabel: 'Created',
    expenseDateLabel: 'Expense Date',
    invalidDate: 'Invalid Date',
    naLabel: 'N/A',
    productsCount: 'Products',

    // Users page
    passwordMinimum: "Minimum 6 characters. Leave empty if you don't want to change the password.",
  }
};